export default __webpack_public_path__ + "static/media/phone_blue.e16b36b4.svg";